import $ from 'jquery'
import Base from 'luminate/src/modules/base'

export default Base.extend({
	directive: 'gallery',

	modules: {
		thumbs: Base.extend({
			directive: 'thumb',

			events: {
				init: function()
				{
					this.$settings.url = this.$element.href
				}
			}
		})
	},

	events: {

		init: function()
		{
			if(!window.PhotoSwipe || !window.PhotoSwipeUI_Default)
			{
				throw new Error('PhotoSwipe library and/or UI theme not loaded.');
			}

			const $pswp = $('#pswp-gallery-' + this.$settings.pswp)
			const items = []
			const thumbs = this.$owns.thumbs

			thumbs.forEach((thumb, i) =>
			{
				const $thumb = $(thumb.$element)
				const $thumbImg = $thumb.children('img')

				items.push({
					src: thumb.$settings.url,
					w: thumb.$settings.width,
					h: thumb.$settings.height,
					title: $thumb.prop('title') || $thumbImg.prop('alt'),
					msrc: $thumbImg.prop('src')
				})

				$thumb.on('click', (e) =>
				{
					e.preventDefault()

					const options = {
						index: i,
						history: false,
						showHideOpacity: true,

						getThumbBoundsFn: (index) =>
						{
							const thumb = thumbs[index]
							const thumbnail = $(thumb.$element).children('img')[0]
							const pageYScroll = window.pageYOffset || document.documentElement.scrollTop
							const rect = thumbnail.getBoundingClientRect()

							return {
								x: rect.left,
								y: rect.top + pageYScroll,
								w: rect.width
							}
						}
					}

					const gallery = new PhotoSwipe($pswp[0], PhotoSwipeUI_Default, items, options)
					gallery.init()
				})
			})
		}
	}
})



// WEBPACK FOOTER //
// ./public/scripts/src/modules/gallery.js